<template>
  <div>
    <div>
      <div class="header_margin">      
      </div>    
    </div>
    <div align="center" justify="center">      
      <div class="text-center" id="blinking">
        <h2 id="typing-demo" class="white--text mt-8 mb-1  font-weight-light"></h2>
        <img                    
          src="../assets/logo_white.png"           
          width="300px"          
        />
      </div>      
      
    </div>
    
    <div>
      
      <div class="header_margin">
      </div>
      <div class="text-right" style="position: relative; width:100%; right:10px; top:-50px; color : #ffffffe0; font-size: 12px; font-weight: 300; ">The images used on this website were created using AI technology.</div>
    </div>
		
		<div id="scoll_About" align="center" justify="center" >      
      <div class="mt-10">
        <div class="title_caption">ABOUT</div>
        <div class="title_header">M4 company</div>
        <div class="title_sub">Digital transformation of all indoor spaces with AI.</div>
      </div>        
      <div class="d-flex justify-center flex-wrap" color="white" style="display: flex; align-items: center;">
        <div class="ma-3" style="">                            
          <img                              
            src="../assets/about.png"           
            width="300px"/>                            
        
        </div>
        <div class="ma-3" style="width : 400px">                            
          <div class="content_header text-left">
            A company that generates<br>
            the most valueable, fastest and<br>
            most accurate<br> 
            indoor spatial information<br>
            with AI
          </div>
          <div class="content_caption text-left mt-4">
            M4 Company has core technologies such as AI-based 3D map generation solution, RTLS, and IoT, and is creating a beneficial, sustainable and valuable future for the company, customers, and everyone in the world with Triple Win's relationship orientation.
          </div>
        </div>
      </div>
      
    </div>


  </div>
</template>


<script>
import axios from "axios"
import router from "@/router/index"

export default {
  metaInfo: {
    // title 입력하기
    title: '3D 실내지도, 3D Indoor Map, RTLS, 실내측위, AI - M4Company',
    // link tag 입력하기
    // link: [{rel: "canonical", href: 'www.site.com'}],
    // meta tag 입력하기
    meta: [
      { charset: 'utf-8' },
      { name: 'viewport', content: 'width=device-width, initial-scale=1' },
      { vmid: "description", name: "description", content: '자체 개발한 3D Indoor Mapping Tool을 이용하여 쉽고, 빠르고, 효율적인 비용으로 3D 실내지도를 제작하고 BLE, UWB 실내측위 기술로 실시간 위치정보(RTLS)를 제공하고 IoT, AI 기술을 활용하여 다양한 서비스를 제공합니다.' }
      //vmid ↑ 메타 태그를 고유하게 만들어준다.
    ]
  },

  data: () => ({ 
    dialog : false,
    renderForce : false,
    version : "",    
    videoPath : null,    
  }),
  watch: {
    dialog(val) {
      val || this.close();
    },

  },
	
	created () {
      let locale = navigator.language || navigator.userLanguage
      locale = locale.substring(0, 2)
      if (locale != 'ko') locale = 'en'
      if (locale == 'ko') {
				router.push({ name: "ko" });
			} else {
				router.push({ name: "en" });
			}
    },

  mounted () {                
    this.version = localStorage.getItem("Version");
    //console.log('current version :', this.version);  
    
    // 버전업이 되었으면 버전을 올리도록 처리  
    if (process.env.NODE_ENV === 'production') {  
      //console.log('version update check...');  
      //console.log(caches);  
      axios
        .get(`/version.json?timestamp=${new Date().getTime()}`)
        .then(res => {  
        //console.log('server version :', res.data.version);  
        if (res.data.version != this.version) {              
          if (this.version != "") {
            //this.deleteCash();                      
          } 
          localStorage.setItem("Version", res.data.version);                       
        }  
      });  
    }
  },
  methods: {
  }
}
</script>

<style scoped>
.header_margin {    
  width:100%;
  height:150px;  
}
/* .header_text {    
  background: #000000;   
} */
.content_get {    
  z-index: 2;
  width:100%;
  float:top;
  background: #FFFFFF;   
}
.content_why {    
  width:100%;  
  background: #2A2A2A;   
}


#content_about {    
  width:80%;    
  line-height:200%;
}

#line-height {
  line-height:200%;
}

#item-box {
  width:300px;
  line-height:200%;
}

#item-box2 {
  width:200px;
  line-height:200%;
}
#item-box3 {
  width:400px;
  line-height:200%;
}



#blinking{
	-webkit-animation:blink 3s ease-in-out infinite alternate;
    -moz-animation:blink 3s ease-in-out infinite alternate;
    animation:blink 3s ease-in-out infinite alternate;
}
@-webkit-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@-moz-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
} 


  .magnifyBorder {
    width:240px;
    line-height:200%;
    background: #FFFFFFAA;

    padding: 18px 36px;
    border-radius: 5px;
    box-shadow: inset 0 0 0 0.2px #222222;;
    transition: 300ms box-shadow cubic-bezier(0.4, 0, 0.6, 1), 300ms background-color cubic-bezier(0.4, 0, 0.6, 1), 300ms color cubic-bezier(0.4, 0, 0.6, 1);;
    color: #222222;
  }

  .magnifyBorder:hover {
      background: #FFFFFFE0;
      box-shadow: inset 0 0 0 4px #D6433B;
      color : #222222;
  }


  .class_play_btn{
    z-index: 200;
    position: relative;
    top : 70px;
    height : 0px;
  }

  .video_x_button{
    z-index: 100;
    position: absolute;    
    top : 0px;
    left : 0px;
    height: 25px;
    width : 100%;
    background: #00000000;   
  }

  .circle{
    border-radius: 50%;
    background: #00000010;   
    height : 200px;
    width : 200px;
    text-align: center;
    line-height: 200px;    
    font-size: 40px;
    
  }



#blinking1{
	-webkit-animation:blink 5s ease-in-out infinite alternate;
    -moz-animation:blink 5s ease-in-out infinite alternate;
    animation:blink 5s ease-in-out infinite alternate;
}
@-webkit-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@-moz-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
} 



#blinking2{
	-webkit-animation:blink 6s ease-in-out infinite alternate;
    -moz-animation:blink 6s ease-in-out infinite alternate;
    animation:blink 6s ease-in-out infinite alternate;
}
@-webkit-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@-moz-keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
}
@keyframes blink{
    0% {opacity:0.3;}
    100% {opacity:1;}
} 

  .title_caption {
    color:#00000030;
    font-weight: 400;
    font-size: 30px;
  }
  .title_header {
    color:#000000C0;
    font-weight: 700;
    font-size: 60px;
  }
  .title_header2 {
    color:#000000C0;
    font-weight: 700;
    font-size: 45px;
  }
  .title_sub {
    color:#000000C0;
    font-weight: 500;
    font-size: 25px;
  }
  .content_header {
    color:#000000C0;
    font-weight: 500;
    font-size: 23px;
  }
  .content_caption {
    color:#000000A0;
    font-weight: 300;
    font-size: 15px;
  }

  .image_title {    
    background: #00000010;
    height : 50px;
    display: flex;
    justify-content: center;
    align-items: center;
    -ms-overflow-style: none; /* IE and Edge */
    scrollbar-width: none; /* Firefox */

    border-radius: 5px;  
  }

  .img_outline {
    border-radius: 10px; /* 모서리 둥글게 */
  }

  /* video[poster]{ 
    height:100%;
    width:100%;
    } */


</style>





<!--  -->